import axiosInstance from "./AxiosInstance";

export function getDoctors(pagination, pageid,search_by = "", search_keyword = "", sort_by = "",sort_order = "") {
  return axiosInstance.post("/admin/doctorList", {
    pagination, pageid ,search_by, search_keyword, sort_by, sort_order
  });
}

export function createDoctor(
  token,
  admin_id,
  doctor_username,
  doctor_password,
  doctor_code,
  doctor_name,
  specialization,
  contact_number,
  email_address,
  address,
  consultation_mode,
  consulting_duration_first_time,
  followup_patient,
  doctor_status,
  doctor_type,
  opening_hrs
) {
  return axiosInstance.post("/admin/addDoctor", {
    token,
    admin_id,
    doctor_username,
    doctor_password,
    doctor_code,
    doctor_name,
    specialization,
    contact_number,
    email_address,
    address,
    consultation_mode,
    consulting_duration_first_time,
    followup_patient,
    doctor_status,
    doctor_type,
    opening_hrs,
  });
}


export function updateDoctor(doctorData, doctorId) {
  return axiosInstance.post(`/admin/updateDoctor`, {
    ...doctorData,
    doctor_id: doctorId,
  });
}

export function deleteDoctor(doctor_id) {
  return axiosInstance.post(`/admin/deleteDoctor`, {
    doctor_id: doctor_id
  });
}

export function formatDoctors(responseData) {
  if (!responseData) return [];

  if (Array.isArray(responseData)) {
    return responseData.map((doctor) => ({
      ...doctor,
      doctor_id: doctor.doctor_id || doctor._id || doctor.id,
    }));
  }

  let doctors = [];
  for (let key in responseData) {
    if (responseData.hasOwnProperty(key)) {
      doctors.push({
        ...responseData[key],
        doctor_id:
          responseData[key].doctor_id ||
          responseData[key]._id ||
          responseData[key].id ||
          key,
      });
    }
  }
  return doctors;
}